module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', {
    staticClass: "header-h1"
  }, [_vm._v(_vm._s(_vm.locale.t('label_invoices')))]), _vm._v(" "), (this.$sessionService.getRole() === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.addInvoice()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_add_invoice')) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex-container section-top"
  }, [(this.$sessionService.getRole() === 'ROLE_SUPER_ADMIN' || this.$sessionService.getRole() === 'ROLE_ADMIN') ? _c('div', {
    staticClass: "current-balance width-fifth",
    style: (_vm.currentBalance > 0 ? 'border: 2px solid green;' : _vm.currentBalance === 0 ? 'border: 2px solid white;' : 'border: 2px solid red;')
  }, [_c('p', {
    staticClass: "payment-item-text text-center"
  }, [_vm._v(_vm._s(_vm.locale.t('label_current_balance')) + ": "), _c('b', {
    style: (_vm.currentBalance > 0 ? 'color: green;' : 'color: red;')
  }, [_vm._v(_vm._s(_vm.currentBalance) + "  €")])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_from')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_to')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_created')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_amount')) + " €")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_paid')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_number_user_for_invoice')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_download_pdf')))]), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN') ? _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_set_paid')))]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN') ? _c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_delete')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredInvoices), function(item) {
    return _c('tr', [_c('td', {
      style: (_vm.getPaymentClassTd(item)),
      attrs: {
        "data-title": _vm.locale.t('label_from')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(item.fromPeriod)) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(item)),
      attrs: {
        "data-title": _vm.locale.t('label_to')
      }
    }, [_vm._v("\n                " + _vm._s(_vm.formatDate(item.toPeriod)) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(item)),
      attrs: {
        "data-title": _vm.locale.t('label_created')
      }
    }, [_vm._v("\n                " + _vm._s(_vm.formatDate(item.createdTime)) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(item)),
      attrs: {
        "data-title": _vm.locale.t('label_amount')
      }
    }, [_vm._v("\n                " + _vm._s(item.displayAmount) + "  €\n              ")]), _vm._v(" "), _c('td', {
      style: (item.isPaid ? 'color: white;' : 'color: red;'),
      attrs: {
        "data-title": _vm.locale.t('label_paid')
      }
    }, [_vm._v("\n                  " + _vm._s(item.isPaid ? _vm.locale.t('label_paid_yes') : _vm.locale.t('label_paid_no')) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(item)),
      attrs: {
        "data-title": _vm.locale.t('label_number_user_for_invoice')
      }
    }, [_vm._v("\n                " + _vm._s(item.itemCount) + "\n              ")]), _vm._v(" "), _c('td', {
      style: (_vm.getPaymentClassTd(item)),
      attrs: {
        "data-title": _vm.locale.t('label_download_pdf')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.generatePdf(item, true)
        }
      }
    }, [_c('i', {
      staticClass: "ti-download"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_pdf')) + "\n                ")])]), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN') ? _c('td', {
      style: (_vm.getPaymentClassTd(item)),
      attrs: {
        "data-title": _vm.locale.t('label_set_paid')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.setPaid(item)
        }
      }
    }, [_c('i', {
      staticClass: "ti-money"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_set_paid')) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN') ? _c('td', {
      style: (_vm.getPaymentClassTd(item)),
      attrs: {
        "data-title": _vm.locale.t('label_delete')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteInvoice(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                ")])]) : _vm._e()])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e2fc843!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoice/Invoices.vue
// module id = 763
// module chunks = 0